var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-ticket-money",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('member-icon',{attrs:{"grade":_vm.grade}}),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm.$t(`grade.${_vm.grade}`))+"价 ￥"+_vm._s(_vm.price))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }